export const language: any = {
    OkLogout: "ဟုတ်ကဲ့",
    CloseLogout: "မလုပ်ပါ",
    OkLeave: "ထွက်မည်",
    CloseLeave: "ပယ်ဖျက်မည်",
    LabelPolicy: "ကိုယ်ရေးအချက်အလက် ကာကွယ်စောင့်ရှောက်မှု မူဝါဒ",
    AppName: "Hey! Cooker",
    OnOffNotification: "အသိပေးချက် ဖွင့်/ပိတ်",
    LabelReceiveNotificationSuggestion: "ချက်ပြုတ်နည်းအကြံပြုချက် အသိပေးချက်လက်ခံရန်",
    LabelReceiveNotifyBreakfast: "နေ့စဉ် မနက်စာ အကြံပြုချက်လက်ခံရန်",
    LabelReceiveNotifyLunch: "နေ့စဉ် နေ့လယ်စာ အကြံပြုချက်လက်ခံရန်",
    LabelReceiveNotifyDinner: "နေ့စဉ် ညစာ အကြံပြုချက်လက်ခံရန်",
    notification_history: "သတင်းမှတ်တမ်း",
    readAll: "အားလုံးဖတ်ပါ",
    no_notification: "သတင်းမှတ်တမ်းမရှိပါဘူး",
    labelDisplayName: "ပြသမည့်အမည်ကို ထည့်ပါ",
    placeholderDisplayName: "အနည်းဆုံး 4 လုံး၊ အများဆုံး 20 လုံးထည့်ပါ",
    changeDisplayName: "ပြသမည့်အမည်ကို ပြောင်းပါ",
};
